import { PrismicCheckoutConfiguration } from "../prismic/PrismicModels"
import React from "react"

export const CheckoutConfigContext = React.createContext<{
  config: PrismicCheckoutConfiguration
}>({ config: { disabled: false } })
